import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { JobProgress } from "@/components/JobProgress";

const RECENT_MS = 10 * 60 * 1000;

// Fortschritt/Ergebnis der letzten Versandmitteilung im Auftrag (Dialog darf geschlossen werden; hier wird weiter gepollt)
export const VersandJobBanner = ({ orderId, refreshKey = 0, onDone }) => {
  const [job, setJob] = useState(null);
  const [hidden, setHidden] = useState(null);
  const prev = useRef(null);

  useEffect(() => {
    let alive = true, timer;
    const tick = async () => {
      try {
        const r = await api.get(`/auftraege/${orderId}/versand-jobs`);
        if (!alive) return;
        const j = r.data[0] || null;
        if (prev.current?.status === "laeuft" && j && j.id === prev.current.id && j.status !== "laeuft") onDone?.(j);
        prev.current = j; setJob(j);
        if (j?.status === "laeuft") timer = setTimeout(tick, 1500);
      } catch { /* still */ }
    };
    tick();
    return () => { alive = false; clearTimeout(timer); };
  }, [orderId, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!job || hidden === job.id) return null;
  if (job.status !== "laeuft" && Date.now() - new Date(job.updated_at).getTime() > RECENT_MS) return null;
  const tone = job.status === "fehler" ? "border-rose-200 bg-rose-50" : job.status === "fertig" ? "border-emerald-200 bg-emerald-50" : "border-blue-200 bg-blue-50";
  const title = job.status === "laeuft" ? "Versandmitteilung wird verarbeitet…" : job.status === "fertig"
    ? `Versandmitteilung eingereiht${job.result?.mit_rechnung ? ` mit Rechnung ${job.result.rechnungsnummer}` : ""}${job.params?.test_mode ? " (Test)" : ""}`
    : "Versandmitteilung nicht gesendet";
  return (
    <Card className={tone} data-testid="versand-job-banner" data-status={job.status}>
      <CardContent className="p-4 space-y-2">
        <div className="flex items-start gap-3">
          <div className="flex-1 text-sm font-semibold text-slate-900">{title}</div>
          {job.status !== "laeuft" && <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => setHidden(job.id)} aria-label="Hinweis ausblenden" data-testid="versand-job-banner-close"><X className="w-4 h-4" /></Button>}
        </div>
        <JobProgress job={job} testId="versand-job-banner-steps" />
        {job.error?.message && <p className="text-sm text-rose-800" data-testid="versand-job-banner-error">{job.error.message}</p>}
      </CardContent>
    </Card>
  );
};
